import { Component, OnInit, signal, inject } from "@angular/core";
import { QuotaAccount } from "src/app/shared/contract/PromoCode/QuotaAccount";
import { ReceptionService } from "../reception.service";
import { catchError, finalize, tap } from "rxjs/operators";
import { of } from "rxjs";
import { MatDialogRef } from "@angular/material/dialog";
import { DialogContainerComponent } from "@components/dialog-container/dialog-container.component";
import { TableSkeletonLoaderComponent } from "../../skeleton-presets/table-skeleton-loader/table-skeleton-loader.component";
import { DatePipe } from "@angular/common";
import { TranslocoPipe } from "@jsverse/transloco";
@Component({
  selector: "app-package-overview",
  templateUrl: "./package-overview.component.html",
  styleUrls: ["./package-overview.component.scss"],
  imports: [DialogContainerComponent, TableSkeletonLoaderComponent, DatePipe, TranslocoPipe]
})
export class PackageOverviewComponent implements OnInit {
  private receptionService = inject(ReceptionService);
  private matDialogRef = inject<MatDialogRef<PackageOverviewComponent>>(MatDialogRef);

  public purchaseHistoryOverview = signal<QuotaAccount[]>([]);
  isLoading = signal<boolean>(true);

  ngOnInit() {
    this.purchaseHistoryOverview.set([]);
    this.loadOverview();
  }

  private loadOverview() {
    this.receptionService
      .getPackageOverview()
      .pipe(
        tap(() => this.isLoading.set(true)),
        catchError(err => {
          console.error("Error loading package overview:", err);
          return of([]);
        }),
        finalize(() => this.isLoading.set(false))
      )
      .subscribe(data => {
        if (data && Array.isArray(data)) {
          this.purchaseHistoryOverview.set(data);
        } else {
          this.purchaseHistoryOverview.set([]);
        }
      });
  }

  closeDialog() {
    this.matDialogRef.close();
  }
}
